import React from 'react';
import * as Styles from './DomainNotRegistered.styles';
import {
  IconCart, Button,
  IconExternalLink,
} from 'gatorcomponents';
import { NavigatorInput } from '@/pages/Domains/ChangeDomainHandler/components/NavigatorInput';

const DomainNotRegistered = ({
  locale, backButton, goToPurchase, newDomain, mySiteLabel, mobile,
}) => {
  const handleBackButton = () => {
    backButton && backButton();
  };

  const handleGoToPurchase = () => {
    goToPurchase && goToPurchase();
  };

  return (
    <Styles.Wrapper data-testid="domain-not-registered">
      <Styles.HeadWrapper>
        <Styles.IconCircle>
          <IconCart color="primaryBlue" />
        </Styles.IconCircle>
        <Styles.Wrapper>
          <Styles.Title>
            {locale.title(newDomain)}
          </Styles.Title>
          <Styles.Description>
            {locale.description}
          </Styles.Description>

        </Styles.Wrapper>
      </Styles.HeadWrapper>
      <NavigatorInput newDomain={newDomain} mySiteLabel={mySiteLabel} showNavigator={!mobile} />
      <Styles.ButtonsWrapper>
        <Button
          label={locale.buttonBackLabel}
          variant="tertiary"
          width="fit"
          size="medium2"
          onClick={handleBackButton}
          testId="back-button"
        />
        <Button
          label={locale.buttonContinueLabel}
          variant="primary"
          width="fit"
          size="medium2"
          iconRight={<IconExternalLink color="highPure" secondaryColor="transparent" size="sm" />}
          notFillSVG
          onClick={handleGoToPurchase}
          testId="go-to-purchase-button"
        />
      </Styles.ButtonsWrapper>
    </Styles.Wrapper>
  );
};

export default DomainNotRegistered;
